const { event } = require("jquery")

// 動作していない　ここから
$(document).on ('ajax:success', '#billing-statement-csv-download-form', (event) => {
  data = event.detail[0], http_status = event.detail[1], xhr = event.detail[2]
  console.log('success!')

  url = $('#data-store').data('redirect-path-csv-dl-succeed')
  window.location.href = url
})
// 動作していない　ここまで

$(document).on('change', '#statement-search-type-selector', () => {
  search_type = $('#statement-search-type-selector').find('option:selected').val()

  if (search_type == 'owner') {
    $('#billing_statement_search_form_owner_all').prop('disabled', false)
    $('.owner-area').css('display', 'block')
    $('#billing_statement_search_form_hotel_all').prop('disabled', true)
    $('.hotel-area').hide()
  } else {
    $('#billing_statement_search_form_owner_all').prop('disabled', true)
    $('.owner-area').hide()
    $('#billing_statement_search_form_hotel_all').prop('disabled', false)
    $('.hotel-area').css('display', 'block')
  }
})

$(document).on('change', '#statement_select_statement_all', () => {
  checked = $('#statement_select_statement_all').prop('checked')
  $('.statement-checkbox').prop('checked', checked)
})

$(document).on ('change', '.statement-checkbox', () => {
  if ($('.statement-checkbox:checked').length == $('.statement-checkbox:input').length){
    $('#statement_select_statement_all').prop('checked', true)
  } else {
    $('#statement_select_statement_all').prop('checked', false)
  }
})

$(document).on('click', '#send-statement-json-form-button', () => {
  ids = checkedStatementsIds()
  $('#checked-statement-ids-for-json').val(ids)

  document.getElementById('statement-send-json-form').submit()
})

$(document).on('click', '#aggregate-statement-form-button', () => {
  ids = checkedStatementsIds()
  $('#checked-statement-ids-for-aggregate').val(ids)

  document.getElementById('statement-aggregate-form').submit()
})

$(document).on('click', '#destroy-statement-form-button', () => {
  ids = checkedStatementsIds()
  $('#checked-statement-ids-for-destroy').val(ids)

  document.getElementById('statement-destroy-form').submit()
})

function checkedStatementsIds () {
  statements = $('.statement-checkbox:checked')
  ids = []
  statements.each((idx, statement) => {
    id = $(statement).attr('id')
    id = id.split('_')[3]
    ids.push(id)
  })
  return ids
}
